interface BrandAvatarProps {
  avatarUrl: string | null;
  size: number;
  alt: string;
  /** Optional border (CSS shorthand, used by Instagram's gradient ring, etc.). */
  ring?: string;
}

export const BrandAvatar = ({ avatarUrl, size, alt, ring }: BrandAvatarProps) => (
  <div
    className="overflow-hidden rounded-full shrink-0 bg-gray-300"
    style={{ width: size, height: size, border: ring }}
  >
    {avatarUrl ? (
      <img src={avatarUrl} alt={alt} className="block w-full h-full object-cover" />
    ) : null}
  </div>
);

BrandAvatar.displayName = 'BrandAvatar';
